var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 567,
    height: 471,
    viewBox: "0 0 567 471",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7674_12987)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M526.424 75.0569H548.925",
    stroke: "#545454",
    strokeWidth: 3.02549,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.67 86.3115V63.8105",
    stroke: "#545454",
    strokeWidth: 3.02549,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3013 435.815H74.8023",
    stroke: "#545454",
    strokeWidth: 3.02549,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5471 447.061V424.56",
    stroke: "#545454",
    strokeWidth: 3.02549,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.959 41.7334H565.28",
    stroke: "#545454",
    strokeWidth: 3.02549,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.624 48.398V35.0686",
    stroke: "#545454",
    strokeWidth: 3.02549,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 430.343H15.3208",
    stroke: "#545454",
    strokeWidth: 3.02549,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.65625 437.008V423.679",
    stroke: "#545454",
    strokeWidth: 3.02549,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.5 96.8318H523.01",
    stroke: "#545454",
    strokeWidth: 3.02549,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8491 379.636H70.3588",
    stroke: "#545454",
    strokeWidth: 3.02549,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.148 304.188H402.287C397.965 320.002 411.476 334.888 423.249 334.888C436.708 334.888 445.439 323.996 445.439 308.835C445.439 296.518 440.321 284.294 430.087 283.779C421.728 283.367 414.657 293.03 414.657 305.374C414.657 314.299 419.662 321.17 424.416 321.17C430.467 321.17 434.668 315.664 434.668 304.352H416.982",
    stroke: "#545454",
    strokeWidth: 3.02549,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.174 321.239H404.439",
    stroke: "#545454",
    strokeWidth: 3.02549,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.366 283.766H385.508",
    stroke: "#545454",
    strokeWidth: 3.02549,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.045 334.897H373.052",
    stroke: "#545454",
    strokeWidth: 3.02549,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.77 333.998C190.313 336.254 183.129 337.802 174.874 337.802C163.178 337.802 153.704 334.707 153.704 330.886V322.432",
    stroke: "#545454",
    strokeWidth: 3.02549,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.803 325.717C182.881 326.541 178.882 326.944 174.874 326.918C163.178 326.918 153.704 323.815 153.704 320.003V310.494",
    stroke: "#545454",
    strokeWidth: 3.02549,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.137 314.107C182.435 314.828 178.671 315.181 174.9 315.162C163.204 315.162 153.73 312.067 153.73 308.247V296.525",
    stroke: "#545454",
    strokeWidth: 3.02549,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.742 290.811C182.84 289.991 178.861 289.591 174.874 289.619C163.178 289.619 153.704 292.713 153.704 296.534C153.704 300.355 163.213 303.449 174.874 303.449C178.714 303.479 182.545 303.109 186.307 302.345",
    stroke: "#545454",
    strokeWidth: 3.02549,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.6 321.075V330.86C153.6 334.681 144.091 337.775 132.43 337.775C120.769 337.775 111.269 334.681 111.269 330.86V319.692",
    stroke: "#545454",
    strokeWidth: 3.02549,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.6 309.319V319.13C153.6 322.951 144.091 326.046 132.43 326.046C120.769 326.046 111.269 322.942 111.269 319.13V307.482",
    stroke: "#545454",
    strokeWidth: 3.02549,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.431 314.35C144.122 314.35 153.6 311.25 153.6 307.426C153.6 303.601 144.122 300.501 132.431 300.501C120.739 300.501 111.261 303.601 111.261 307.426C111.261 311.25 120.739 314.35 132.431 314.35Z",
    stroke: "#545454",
    strokeWidth: 3.02549,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.536 170.734V153.653C256.548 150.408 257.842 147.299 260.136 145.004C262.431 142.71 265.54 141.415 268.785 141.404H320.953C324.2 141.411 327.313 142.703 329.61 144.999C331.907 147.294 333.202 150.406 333.211 153.653V170.656",
    stroke: "#545454",
    strokeWidth: 3.02549,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.779 170.172L270.142 160.473C270.219 158.835 270.92 157.288 272.102 156.15C273.283 155.012 274.855 154.369 276.495 154.353H312.948C313.742 154.35 314.529 154.508 315.26 154.817C315.992 155.127 316.653 155.581 317.204 156.153C317.755 156.725 318.184 157.403 318.466 158.145C318.748 158.888 318.876 159.68 318.844 160.473L318.481 170.172",
    stroke: "#545454",
    strokeWidth: 3.02549,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.652 335.018H200.859C190.632 335.018 186.872 327.238 186.872 322.916L186.872 237.017",
    stroke: "#545454",
    strokeWidth: 3.02549,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.769 171.875C344.396 175.082 344.906 183.77 344.906 192.319C344.906 203.072 344.629 237.571 344.629 237.571C344.629 241.893 340.589 249.673 330.011 249.673",
    stroke: "#545454",
    strokeWidth: 3.02549,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.193 249.647C189.976 249.647 186.85 241.683 186.85 237.361V192.411C186.85 181.649 188.316 170.578 209.295 170.578H354.899",
    stroke: "#545454",
    strokeWidth: 3.02549,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.309 205.25L424.183 115.722L400.938 105.634L364.52 188.887",
    stroke: "#545454",
    strokeWidth: 3.02549,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.114 201.369L372.81 157.223L372.136 136.019L360.587 153.99L348.027 201.136",
    stroke: "#545454",
    strokeWidth: 3.02549,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.336 202.804V202.502H344.777L344.612 322.942C344.612 327.264 340.852 335.044 330.626 335.044H371.349C381.567 335.044 385.336 327.264 385.336 322.942V202.787",
    stroke: "#545454",
    strokeWidth: 3.02549,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.068 232.453V192.604C227.068 181.842 229.177 170.587 250.157 170.587H233.223C212.252 170.587 210.143 181.825 210.143 192.604V232.981",
    stroke: "#545454",
    strokeWidth: 3.02549,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.143 265.475V270.255C210.213 272.44 211.13 274.513 212.7 276.033C214.271 277.554 216.371 278.405 218.558 278.405C220.744 278.405 222.845 277.554 224.415 276.033C225.986 274.513 226.903 272.44 226.973 270.255V264.878",
    stroke: "#545454",
    strokeWidth: 3.02549,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.279 232.938H200.495V264.939H238.279V232.938Z",
    stroke: "#545454",
    strokeWidth: 3.02549,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.223 242.87H211.56V254.998H227.223V242.87Z",
    stroke: "#545454",
    strokeWidth: 3.02549,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.245 232.453V192.604C317.245 181.842 319.354 170.587 340.334 170.587H323.4C302.429 170.587 300.319 181.825 300.319 192.604V232.981",
    stroke: "#545454",
    strokeWidth: 3.02549,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.319 265.475V270.255C300.389 272.44 301.307 274.513 302.877 276.033C304.448 277.554 306.548 278.405 308.735 278.405C310.921 278.405 313.021 277.554 314.592 276.033C316.162 274.513 317.08 272.44 317.15 270.255V264.878",
    stroke: "#545454",
    strokeWidth: 3.02549,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.456 232.938H290.672V264.939H328.456V232.938Z",
    stroke: "#545454",
    strokeWidth: 3.02549,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.391 242.87H301.728V254.998H317.391V242.87Z",
    stroke: "#545454",
    strokeWidth: 3.02549,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.732 334.024V318.335C211.728 316.823 211.125 315.374 210.056 314.305C208.987 313.237 207.539 312.634 206.027 312.629H188.186",
    stroke: "#545454",
    strokeWidth: 3.02549,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.578 334.888V318.335C319.583 316.823 320.185 315.374 321.254 314.305C322.323 313.237 323.772 312.634 325.283 312.629H343.125",
    stroke: "#545454",
    strokeWidth: 3.02549,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.587 153.99L372.81 157.223",
    stroke: "#545454",
    strokeWidth: 3.02549,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.975 126.778L416.852 130.417",
    stroke: "#545454",
    strokeWidth: 3.02549,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.111 141.923L409.989 145.553",
    stroke: "#545454",
    strokeWidth: 3.02549,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.248 157.059L403.125 160.698",
    stroke: "#545454",
    strokeWidth: 3.02549,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.384 172.203L396.262 175.834",
    stroke: "#545454",
    strokeWidth: 3.02549,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.521 187.34L389.398 190.979",
    stroke: "#545454",
    strokeWidth: 3.02549,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.373 241.297H408.883",
    stroke: "#545454",
    strokeWidth: 3.02549,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.627 252.552V230.042",
    stroke: "#545454",
    strokeWidth: 3.02549,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.319 173.33H455.829",
    stroke: "#545454",
    strokeWidth: 3.02549,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.575 184.585V162.075",
    stroke: "#545454",
    strokeWidth: 3.02549,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.738 198.147H435.239",
    stroke: "#545454",
    strokeWidth: 3.02549,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.684 371.111H165.194",
    stroke: "#545454",
    strokeWidth: 3.02549,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.939 382.357V359.856",
    stroke: "#545454",
    strokeWidth: 3.02549,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81 406H103.501",
    stroke: "#545454",
    strokeWidth: 3.02549,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142 272H164.501",
    stroke: "#545454",
    strokeWidth: 3.02549,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.586 249.89H290.62",
    stroke: "#545454",
    strokeWidth: 3.02549,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.908 52.0374C516.441 52.0374 520.927 47.5519 520.927 42.0187C520.927 36.4855 516.441 32 510.908 32C505.375 32 500.889 36.4855 500.889 42.0187C500.889 47.5519 505.375 52.0374 510.908 52.0374Z",
    stroke: "#545454",
    strokeWidth: 3.02549,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8483 416.054C40.3814 416.054 44.867 411.569 44.867 406.036C44.867 400.503 40.3814 396.017 34.8483 396.017C29.3151 396.017 24.8296 400.503 24.8296 406.036C24.8296 411.569 29.3151 416.054 34.8483 416.054Z",
    stroke: "#545454",
    strokeWidth: 3.02549,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.631 367.217C194.164 367.217 198.65 362.732 198.65 357.198C198.65 351.665 194.164 347.18 188.631 347.18C183.098 347.18 178.612 351.665 178.612 357.198C178.612 362.732 183.098 367.217 188.631 367.217Z",
    stroke: "#545454",
    strokeWidth: 3.02549,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.777 224.495C467.31 224.495 471.795 220.01 471.795 214.477C471.795 208.944 467.31 204.458 461.777 204.458C456.243 204.458 451.758 208.944 451.758 214.477C451.758 220.01 456.243 224.495 461.777 224.495Z",
    stroke: "#545454",
    strokeWidth: 3.02549,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 283.5,
    cy: 235.5,
    r: 221.5,
    stroke: "#F0F0F0",
    strokeWidth: 27
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.5 14C367.355 14 440.326 60.5969 477.933 129.31",
    stroke: "#EE5A00",
    strokeWidth: 27
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7674_12987"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 567,
    height: 471,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMain);
export default __webpack_public_path__ + "static/media/main.f85ce1b6cafdb2f99e1e77ae16a543a9.svg";
export { ForwardRef as ReactComponent };